var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-row',{attrs:{"gutter":16}},[_c('el-form',{attrs:{"label-position":"top"}},[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"error":_vm.showRoomDuplicateName
            ? 'Questo nome è già stato utilizzato'
            : undefined,"label":"Nome camera"}},[_c('jinput',{ref:"roomNameInput",attrs:{"inputDelay":200,"value":_vm.room.get('name'),"type":"text","placeholder":"es. 237"},on:{"change":_vm.setRoomName}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }